import React, { useState } from "react";
import SVGasset from "@/components/atoms/SVGAsset/SVGAsset";

import "./Pagination.css";

interface PaginationProps {
  numberOfPages: number;
  neighbours: number;
  onClick: (number: number) => void;
  // reset: boolean;
}
// TODO => delete when new pagination for my orders table is merged to main

export default function Pagination(props: PaginationProps) {
  const { numberOfPages, onClick, neighbours } = props;
  const [currentActive, setCurrentActive] = useState(1);

  // useEffect(() => {
  //   setCurrentActive(1);
  // }, [reset]);

  const pageNumbers: number[] = [];
  let minPage = 1;
  let maxPage = numberOfPages;
  if (currentActive - neighbours > 1) minPage = currentActive - neighbours;
  if (currentActive + neighbours < numberOfPages) maxPage = currentActive + neighbours;

  for (let i = minPage; i <= maxPage; i++) {
    pageNumbers.push(i);
  }

  const changePageHandler = (number: number) => {
    onClick(number);
    setCurrentActive(number);
  };

  const RenderPageNumbers = () => {
    return pageNumbers.map((number) => {
      const isActive = number === currentActive ? "active" : "";
      return (
        <li
          key={number}
          id={number.toString()}
          onClick={() => changePageHandler(number)}
          className={`clickable ${isActive}`}
        >
          {number}
        </li>
      );
    });
  };

  const clickLeftHandler = () => {
    if (currentActive > 1) changePageHandler(currentActive - 1);
  };

  const clickRightHandler = () => {
    if (currentActive < numberOfPages) changePageHandler(currentActive + 1);
  };

  const showMinPage = currentActive > 1 + neighbours;
  const showMaxPage = currentActive < numberOfPages - neighbours;

  return (
    <div className="pagination-container flex align gap10">
      <div className="clickable" onClick={clickLeftHandler}>
        <SVGasset name="chevron-left" width="24" height="24" />
      </div>
      <ul>
        {showMinPage && (
          <>
            <li className="clickable" onClick={() => changePageHandler(1)}>
              {1}
            </li>
            <li>
              <span>&#8230;</span>
            </li>
          </>
        )}
        <RenderPageNumbers />
        {showMaxPage && (
          <>
            <li>
              <span>&#8230;</span>
            </li>
            <li className="clickable" onClick={() => changePageHandler(numberOfPages)}>
              {numberOfPages}
            </li>
          </>
        )}
      </ul>
      <div className="clickable" onClick={clickRightHandler}>
        <SVGasset name="chevron-right" width="24" height="24" />
      </div>
    </div>
  );
}
